// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__e7t9U","checkbox":"checkbox_checkbox__RWFMG","checkmark":"checkbox_checkmark__H3SUm"};